var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-input',{staticClass:"primary w-full",attrs:{"placeholder":_vm.$t('etaExample')},model:{value:(_vm.etaValue),callback:function ($$v) {_vm.etaValue=$$v},expression:"etaValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }